<div *transloco="let t; read: TRANSLATION_SCOPE" class="d-flex flex-column align-items-center">
  <rx-applications-login-header [authConfig]="authConfig" />
  <div class="text-center">
    <p class="f-size-xs">
      {{
        t('codeDeliveryDestination', {
          destination: authFacade.codeDeliveryDestination$ | async
        })
      }}
    </p>
  </div>
  <rx-alert
    *ngIf="authFacade.error$ | async as error"
    type="danger"
    [message]="t('error.failed')"
    data-qa="test-verify-error"
  ></rx-alert>
  <rx-otp-input
    [error]="authFacade.error$ | async"
    (codeSubmitted)="confirmCode($event)"
    data-qa="test-verify-otp"
  ></rx-otp-input>
  <rx-applications-resend-code [resendTime]="15" (codeResent)="resendCode()" />
</div>
